import {useEffect, useState} from "react";

function useOnShowCreateDocButton(auth, cargoCaseDocument, isNewDocCargoCase, activeDocumentNotFound) {

    const [value, setValue] = useState(false);

    useEffect(() => {
        let isMount = true;

        if (cargoCaseDocument != undefined) {
            if ((auth?.roles[0] === 'CAPTAIN' && auth?.user?.id === cargoCaseDocument[0]?.captain?.id)
                || (auth?.roles[0] === 'FORWARDER' && auth?.login?.toLowerCase() === cargoCaseDocument[0]?.creator?.toLowerCase())
                || (auth?.roles[0] === 'CAPTAIN' && auth?.login?.toLowerCase() === cargoCaseDocument[0]?.creator?.toLowerCase())
                || (auth?.roles[0] === 'CAPTAIN' && isNewDocCargoCase === true)
                || (auth?.roles[0] === 'FORWARDER' && isNewDocCargoCase === true)) {
                isMount && setValue(true)
                } else {
                    isMount && setValue(false)
                }
            } else if (auth?.roles[0] === 'CAPTAIN' && activeDocumentNotFound === true) {
                isMount && setValue(true)
            } else if (auth?.roles[0] === 'FORWARDER' && activeDocumentNotFound === true) {
                isMount && setValue(true)
            }
            else {
                isMount && setValue(false)
            }

            return () => {
                isMount = false;
            }
    },[auth, cargoCaseDocument, isNewDocCargoCase, activeDocumentNotFound])

    return [value, setValue];
}

export default useOnShowCreateDocButton;
